import { render, staticRenderFns } from "./AtomInputPrimary.vue?vue&type=template&id=0c5904ca&"
import script from "./AtomInputPrimary.vue?vue&type=script&lang=js&"
export * from "./AtomInputPrimary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports